export default "__VITE_ASSET__f1qCNU75__"